/**
 * splits a string into words, then returns the first words and last word.
 * @returns tuple<string, string]
 */
export function splitLastWord(str) {
  const words = str.split(" ");
  const firstWords =
    words.length === 1 ? "" : words.splice(0, words.length - 1).join(" ") + " ";
  const lastWord = words[words.length - 1];

  return [firstWords, lastWord];
}
